export default __webpack_public_path__ + "static/media/dashboard.90cef4f3.svg";